import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useUpdate from "./hooks/useUpdate";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";

function Update() {
  const key = useParams()?.key;

  if (!key) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath="/ecommerce/chaves-globais"
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={key}
      hideDeleteButton
    />
  );
}

export default Update;
